import _classCallCheck from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
var Crypto = require("crypto-js");
var Signature = /*#__PURE__*/function () {
  function Signature() {
    _classCallCheck(this, Signature);
  }
  _createClass(Signature, null, [{
    key: "getSignature",
    value: function getSignature(config, date, policyBase64) {
      var getSignatureKey = function getSignatureKey(key, dateStamp, regionName) {
        var kDate = Crypto.HmacSHA256(dateStamp, "AWS4" + key);
        var kRegion = Crypto.HmacSHA256(regionName, kDate);
        var kService = Crypto.HmacSHA256("s3", kRegion);
        var kSigning = Crypto.HmacSHA256("aws4_request", kService);
        return kSigning;
      };
      var signature = function signature(policyEncoded) {
        return Crypto.HmacSHA256(policyEncoded, getSignatureKey(config.secretAccessKey, date, config.region)).toString(Crypto.enc.Hex);
      };
      return signature(policyBase64);
    }
  }]);
  return Signature;
}();
export { Signature as default };